import React from 'react';

import { EDetailsMode } from 'components/Pages/Admin/Itinerary/Details/types';
import ErrorScreen from 'components/shared/ErrorScreen';
import { withLandingPageLayoutContext } from 'components/shared/LandingPage/contexts/LandingPageLayoutContext';
import LandingTranslater from 'components/shared/LandingTranslater';
import Loader from 'components/shared/Loader';
import MobileAppInfo from 'components/shared/MobileAppInfo';
import { ACCOUNT_TYPE_AGENT } from 'constants/index';
import { useDocumentTitle } from 'hooks/useDocumentTitle';
import { AGENT_PERMISSION_TRANSLATE_SERVICE, useIsSubscriptionAllowedExternal } from 'hooks/useIsSubscriptionAllowed';
import { checkIsDeactivatedError } from 'utils/error';
import isNoData from 'utils/isNoData';
import { getLandingTheme } from 'utils/itineraries/functions';

import PDFPreviewDataWrapper from '../../Admin/shared/PDFPreviewDataWrapper';
import { getNotifications } from '../../GuestPortal/LandingLayout/functions';
import { useItineraryPortal, useRenderingKey } from './functions';
import { ItineraryLandingPagesV2 } from './ItineraryLandingPageV2';
import ItineraryLandingPages from './LandingPagesContainer';

function Itinerary() {
  const { itinerary, isLoading, error } = useItineraryPortal();

  if (error) {
    const { errors } = error;
    if (checkIsDeactivatedError(errors)) {
      return (
        <ErrorScreen
          status={errors.title}
          buttonText="Contact"
          coverImage={errors.coverImage}
          buttonAction={(e) => {
            e.preventDefault();
            window.location.href = `mailto: ${errors.email}`;
          }}
          hideStatusCode
        />
      );
    } else {
      return <ErrorScreen status="404" />;
    }
  }

  if (isLoading) {
    return <Loader isFillBlock />;
  }

  if (itinerary.id) {
    if (localStorage.getItem('pdfPreview') === 'true') {
      return <PDFPreviewDataWrapper itemData={itinerary} />;
    }

    const pages = itinerary?.landing?.pages;
    if (isNoData(pages)) {
      return 'No data';
    }

    return <InnerItinerary itinerary={itinerary} pages={pages} />;
  }

  return null;
}

export default Itinerary;

const InnerItinerary = withLandingPageLayoutContext(({ itinerary, pages }) => {
  useDocumentTitle({ title: itinerary.title });

  const isTranslateAllowed = useIsSubscriptionAllowedExternal(
    itinerary.account,
    ACCOUNT_TYPE_AGENT,
    AGENT_PERMISSION_TRANSLATE_SERVICE,
  );
  const landingTheme = getLandingTheme(itinerary);
  const renderingKey = useRenderingKey();
  const isLandingV2 = itinerary.detailsMode === EDetailsMode.Chronological;

  return (
    <>
      {isTranslateAllowed && (
        <LandingTranslater
          translationTrigger={renderingKey}
          translatableId={itinerary.id}
          translatableType={itinerary.type}
        />
      )}
      {isLandingV2 ? (
        <ItineraryLandingPagesV2 data={itinerary} />
      ) : (
        <ItineraryLandingPages
          key={renderingKey}
          pages={pages}
          itineraryItem={itinerary}
          isPrivate={false}
          landingTheme={landingTheme}
          itinerariesItemType={itinerary.type}
          extraHeaderOptionsLandingPageContext={{
            notifications: itinerary.confirmed ? getNotifications(itinerary.id) : undefined,
          }}
        />
      )}
      <MobileAppInfo proposal={itinerary} />
    </>
  );
});
